import React, { useState, useEffect, useRef } from "react";

import { Loader } from "./Components/Loader/loader";
import { Button } from "./Components/Button/Button";
import { InputSuggestion } from "./Components/InputSuggestion/InputSuggestion";
import { Dropdown } from "./Components/SportRoutesDropdown/SportRoutesDropdown";
import { SportRouteSlider } from "./Components/SportRouteSlider/SportRouteSlider";
import { RouteListItem } from "./Components/RouteListItem/RouteListItem";
import TypeFilter from "./Components/TypeFilter/TypeFilter";
import Map from "./MapComponents/Map";
import L from "leaflet";
import { setQueryParam, getQueryParam } from "./Utils/utils";

const SportRoutes = (props) => {
  const {
    IsOverview,
    sportType,
    dictionary,
    redirectRoute,
    linkRoutemeldpunt,
    plannerHorseBack,
    plannerMountainbike,
    meldpuntLinks,
  } = props;

  const locationFilterRef = useRef(null);
  const mbtDistanceFilterRef = useRef(null);
  const mbtPavedFilterRef = useRef(null);
  const mbtDifficultyFilterRef = useRef(null);
  const mbtTypeFilterRef = useRef(null);
  const runDistanceFilterRef = useRef(null);
  const runPavedFilterRef = useRef(null);
  const runTypeFilterRef = useRef(null);
  const horseTypeFilterRef = useRef(null);
  const horsePavedFilterRef = useRef(null);

  const [typeFilterValue, setTypeFilterValue] = useState([]);
  const [locationFilterValue, setLocationFilterValue] = useState({});
  const [filtersData, SetFiltersData] = useState({ "group.id": [] });
  const [mapView, setMapView] = useState(false);
  const [visibleData, setVisibleData] = useState({ clusters: [], routes: [] });
  const [selectedSportType, setSelectedSportType] = useState(null);
  const [selectedSportTypeTitle, setSelectedSportTypeTitle] = useState(
    dictionary.titelAlleroutes
  );
  const [isLoading, setIsLoading] = useState(true);
  const [currentLinkRoutemeldpunt, setCurrentLinkRoutemeldpunt] = useState("");
  const [QueryStringFilter, setQueryStringFilter] = useState();

  const typeFilters = [
    {
      id: "mountainbike",
      name: " typeFilter",
      filterClass: "u-mountainbikeFilter",
      title: dictionary.titelMoutainbikeroutes,
      value: [1933],
      alt: dictionary.zoekTypeMountainbiken,
    },
    {
      id: "run",
      name: "typeFilter",
      filterClass: "u-runFilter",
      title: dictionary.titelLooproutes,
      value: [12045],
      alt: dictionary.zoekTypeLopen,
    },
    {
      id: "kayak",
      name: "typeFilter",
      filterClass: "u-kayakFilter",
      title: dictionary.titelKajakroutes,
      value: [12705],
      alt: dictionary.zoekTypeKajakken,
    },
    {
      id: "multimove",
      name: "typeFilter",
      filterClass: "u-multiMoveFilter",
      title: dictionary.titelMultimoveroutes,
      value: [42540],
      alt: dictionary.zoekTypeMultimove,
    },
    {
      id: "horseback",
      name: "typeFilter",
      filterClass: "u-horsebackFilter",
      title: dictionary.titelPaardrijdroutes,
      value: [16185],
      alt: dictionary.zoekTypePaardrijden,
    },
    {
      id: "skate",
      name: "typeFilter",
      filterClass: "u-skateFilter",
      title: dictionary.titelSkeelerroutes,
      value: [26841],
      alt: dictionary.zoekTypeSkeeleren,
    },
  ];

  const percentagePavedRun = [
    {
      value: null,
      label: dictionary.geenVoorkeur,
    },
    {
      value: 54984,
      label: dictionary.tot20Procent,
    },
    {
      value: 54985,
      label: dictionary.tot40Procent,
    },
    {
      value: 54986,
      label: dictionary.tot60Procent,
    },
    {
      value: 54987,
      label: dictionary.tot80Procent,
    },
    {
      value: 54988,
      label: dictionary.tot100Procent,
    },
  ];

  const percentagePavedMBT = [
    {
      value: null,
      label: dictionary.geenVoorkeur,
    },
    {
      value: 54991,
      label: dictionary.tot20Procent,
    },
    {
      value: 54992,
      label: dictionary.tot40Procent,
    },
    {
      value: 54993,
      label: dictionary.tot60Procent,
    },
    {
      value: 54994,
      label: dictionary.tot80Procent,
    },
    {
      value: 54995,
      label: dictionary.tot100Procent,
    },
  ];

  const percentagePavedHorseback = [
    {
      value: null,
      label: dictionary.geenVoorkeur,
    },
    {
      value: 55736,
      label: dictionary.tot20Procent,
    },
    {
      value: 55737,
      label: dictionary.tot40Procent,
    },
    {
      value: 55738,
      label: dictionary.tot60Procent,
    },
    {
      value: 55739,
      label: dictionary.tot80Procent,
    },
    {
      value: 55740,
      label: dictionary.tot100Procent,
    },
  ];

  const difficultyFilter = [
    {
      value: {
        min: 0,
        max: 1,
      },
      label: dictionary.alleMoeilijkhedenFilter,
    },
    {
      value: {
        min: 0,
        max: 0.5,
      },
      label: dictionary.makkelijkFilter,
    },
    {
      value: {
        min: 0.51,
        max: 0.8,
      },
      label: dictionary.gemiddeldFilter,
    },
    {
      value: {
        min: 0.81,
        max: 1,
      },
      label: dictionary.moeilijkFilter,
    },
  ];

  const horseBackTypes = [
    {
      value: 16185,
      label: dictionary.typeRouteAlle,
    },
    {
      value: 61964,
      label: dictionary.typeRouteMenEnRuiter,
    },
    {
      value: 61963,
      label: dictionary.typeRouteRuiter,
    },
    {
      value: 54950,
      label: dictionary.typeRouteSuggestie,
    },
  ];

  const mountainbikeTypes = [
    {
      value: 1933,
      label: dictionary.typeRouteAlle,
    },
    {
      value: 22825,
      label: dictionary.typeRouteKindVriendelijk,
    },
    {
      value: 43409,
      label: dictionary.typeRouteMarathon,
    },
    {
      value: 27604,
      label: dictionary.typeRouteTechnisch,
    },
    {
      value: 81500,
      label: dictionary.typeRouteGravel,
    },
  ];

  const runTypes = [
    {
      value: 12045,
      label: dictionary.typeRouteLoop,
    },
    {
      value: 10812,
      label: dictionary.typeRouteNatuurlopen,
    },
    {
      value: 52149,
      label: dictionary.typeRouteLoopbaan,
    },
  ];

  useEffect(() => {
    const mapViewQueryString = getQueryParam("view");
    if (mapViewQueryString !== null) {
      setMapView(mapViewQueryString === "true");
    }

    var typeRouteQueryString = getQueryParam("typeroute");
    if (typeRouteQueryString) {
      setQueryStringFilter(typeRouteQueryString);
    }

    if (IsOverview) {
      const paramType = getQueryParam("type");
      //Type mee in querystring
      if (paramType) {
        sportTypeChangeHandler(paramType);
        return;
      }
      //Querystring heeft voorrang op props
      if (sportType !== "") {
        sportTypeChangeHandler(sportType);
      }
    } else {
      if (sportType !== "") {
        sportTypeChangeHandler(sportType, typeRouteQueryString);
      }
    }
  }, []);

  useEffect(() => {
    if (meldpuntLinks && selectedSportType && selectedSportType !== "")
      setCurrentLinkRoutemeldpunt(meldpuntLinks[selectedSportType]);
    else if (linkRoutemeldpunt) {
      setCurrentLinkRoutemeldpunt(linkRoutemeldpunt);
    }
  }, [[selectedSportType, JSON.stringify(meldpuntLinks)]]);

  useEffect(() => {
    if (isLoading) {
      document.addEventListener("keydown", handleKeyDown);
      window.addEventListener("wheel", handleScroll, { passive: false });
    } else {
      document.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("wheel", handleScroll);
    }
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("wheel", handleScroll);
    };
  }, [isLoading]);

  const sportTypeChangeHandler = (type, querystring = null) => {
    const sport = findSportType(type);
    setSelectedSportType(sport.id);
    setTypeFilterValue(sport.value[0]);
    setSelectedSportTypeTitle(sport.title);
    if (!querystring) {
      SetNewFilterData("group.id", sport.value[0]);
    } else {
      SetNewFilterData("group.id", parseInt(querystring));
    }
  };

  // Prevent scrolling in loading screen
  function handleKeyDown(event) {
    if (
      (event.keyCode === 107 && event.ctrlKey === true) ||
      (event.keyCode === 109 && event.ctrlKey === true)
    ) {
      event.preventDefault();
    }
  }

  // Prevent scrolling in loading screen
  function handleScroll(event) {
    if (event.ctrlKey) {
      event.preventDefault();
    }
  }

  const findSportType = (sportTypeId) => {
    let sport = {};
    typeFilters.forEach((type) => {
      if (type.id === sportTypeId) {
        sport = type;
      }
    });
    return sport;
  };

  const handleTypeFilterChange = (e) => {
    //TypeFilterStuff
    setSelectedSportType(e.id);
    setTypeFilterValue(e.value);
    setQueryParam("type", e.id);

    //update Filters
    SetNewFilterData(e.name, e.value);

    //Display the right title
    const sport = findSportType(e.id);
    setSelectedSportTypeTitle(sport.title);
  };

  const resetFilters = () => {
    var sportType = findSportType(selectedSportType);
    SetFiltersData({ "group.id": sportType.value });
    setIsLoading(true);
    setVisibleData({ clusters: [], routes: [] });

    locationFilterRef.current.resetFilter();
    if (selectedSportType === "mountainbike") {
      mbtDifficultyFilterRef.current.resetFilter();
      mbtDistanceFilterRef.current.resetFilter();
      mbtPavedFilterRef.current.resetFilter();
      mbtTypeFilterRef.current.resetFilter();
    } else if (selectedSportType === "run") {
      runDistanceFilterRef.current.resetFilter();
      runPavedFilterRef.current.resetFilter();
      runTypeFilterRef.current.resetFilter();
    } else if (selectedSportType === "horseback") {
      horsePavedFilterRef.current.resetFilter();
      horseTypeFilterRef.current.resetFilter();
    }
  };

  const handleTypeFilterClick = (e) => {
    if (Number(typeFilterValue) === Number(e.value)) {
      setSelectedSportType(null);
      setSelectedSportTypeTitle(dictionary.titelAlleroutes);
      setTypeFilterValue([]);
      SetFiltersData({ "group.id": [] });
      setIsLoading(true);
    }
  };

  const handleLocationFilterChange = (locationObject) => {
    setLocationFilterValue(locationObject);
  };

  const handleSliderFilterChange = (name, sliderObject) => {
    SetNewFilterData("lengthFilter", {
      min: sliderObject.min,
      max: sliderObject.max,
    });
  };

  const SetNewFilterData = (name, value) => {
    const newFilter = {
      [name]: value,
    };

    if (name === "group.id") {
      if (filtersData[name] !== value) {
        SetFiltersData({ [name]: value });
      }
    } else {
      SetFiltersData({ ...filtersData, ...newFilter });
    }

    setIsLoading(true);
    setVisibleData({ clusters: [], routes: [] });
  };

  const resetLocation = (newLocation) => {
    //This is []
    setLocationFilterValue(newLocation);
  };

  const navigateToMeldpunt = () => {
    if (window?.location?.pathname !== currentLinkRoutemeldpunt) {
      window.location.href = `${currentLinkRoutemeldpunt}`;
    }
  };

  const navigateToPlanner = () => {
    if (IsOverview) {
      let navTo = "";
      switch (selectedSportType) {
        case "horseback":
          navTo = plannerHorseBack;
          break;
        case "mountainbike":
          navTo = plannerMountainbike;
          break;
      }
      if (window?.location?.href && window.location.pathname !== navTo) {
        window.location.href = navTo;
      }
    } else {
      if (
        window?.location?.href &&
        window.location.pathname !== `${window.location.pathname}planner`
      ) {
        window.location.href = `https://${window.location.host}${window.location.pathname}planner`;
      }
    }
  };

  const GetMapElements = (data) => {
    if (data.data === undefined) {
      setIsLoading(true);
      setVisibleData({ clusters: [], routes: [] });
    }
    if (data.data !== undefined) {
      setIsLoading(false);
      setVisibleData(data.data);
    }
  };

  const getZoom = () => {
    const zoomLevel = getQueryParam("zoom");

    if (zoomLevel) {
      return zoomLevel;
    } else return 8.4;
  };

  const getCenter = () => {
    const lat = getQueryParam("lat");
    const lng = getQueryParam("lng");

    if (lat && lng) {
      return L.latLng(lat, lng);
    } else return L.latLng(51.0, 4.5);
  };

  const changeMapView = (newValue) => {
    setMapView(newValue);

    setQueryParam("view", newValue);
  };

  return (
    <div className="c-sportroute__container">
      {IsOverview ? (
        <div className="c-sportroute-filter__container-overview">
          <div className="c-sportroute-filter-type__container">
            <p className="c-sportroute-filter__title">{dictionary.zoekType}</p>
            <div className="c-sportroute-filter-type-items__container">
              {typeFilters.map((typeFilter, index) => (
                <TypeFilter
                  changed={handleTypeFilterChange}
                  clicked={handleTypeFilterClick}
                  isSelected={typeFilterValue == typeFilter.value}
                  name="group.id"
                  key={index}
                  properties={typeFilter}
                />
              ))}
            </div>
          </div>

          <div
            className={`c-sportroute-filter-location__container-overview u-filter-margin-top 
            ${
              !selectedSportType || selectedSportType === ""
                ? "c-sportroute-filter-location__solo"
                : selectedSportType === "mountainbike" ||
                  selectedSportType === "horseback"
                ? ""
                : "col-xl-6"
            }`}
          >
            <InputSuggestion
              isFullWidth={true}
              hasLocation={true}
              label={dictionary.zoekLocatiePlaceholder}
              passInputValue={handleLocationFilterChange}
              data={[]}
              ref={locationFilterRef}
            />
          </div>

          {selectedSportType && selectedSportType !== "" && (
            <div
              className={`c-sportroute-nav__container-overview
              ${
                selectedSportType === "horseback" ||
                selectedSportType === "mountainbike"
                  ? ""
                  : "col-xl-2"
              }
            `}
            >
              {selectedSportType === "mountainbike" ? (
                <Button
                  text={dictionary.planJeEigenRoute}
                  icon={"fal fa-route"}
                  toExecute={navigateToPlanner}
                />
              ) : selectedSportType === "horseback" ? (
                <Button
                  text={dictionary.ruiterKnoopPunten}
                  icon={"fal fa-route"}
                  toExecute={navigateToPlanner}
                />
              ) : (
                <></>
              )}
              <Button
                text={dictionary.meldEenProbleem}
                icon={"fal fa-circle-exclamation"}
                toExecute={navigateToMeldpunt}
              />
            </div>
          )}
        </div>
      ) : (
        <div className="c-sportroute-filter__container">
          <div className="c-sportroute-filter-location__container">
            <InputSuggestion
              isFullWidth={true}
              hasLocation={true}
              label={dictionary.zoekLocatiePlaceholder}
              passInputValue={handleLocationFilterChange}
              data={[]}
              ref={locationFilterRef}
            />
          </div>
          <div className="c-sportroute-nav__container">
            {selectedSportType === "mountainbike" ? (
              <Button
                text={dictionary.planJeEigenRoute}
                icon={"fal fa-route"}
                toExecute={navigateToPlanner}
              />
            ) : selectedSportType === "horseback" ? (
              <Button
                text={dictionary.ruiterKnoopPunten}
                icon={"fal fa-route"}
                toExecute={navigateToPlanner}
              />
            ) : (
              <></>
            )}

            <Button
              text={dictionary.meldEenProbleem}
              icon={"fal fa-circle-exclamation"}
              toExecute={navigateToMeldpunt}
            />
          </div>
        </div>
      )}

      <div>
        {selectedSportType === "mountainbike" ||
        selectedSportType === "run" ||
        selectedSportType === "horseback" ? (
          <h4>{selectedSportTypeTitle}</h4>
        ) : (
          <></>
        )}
        <div className="c-sportroute-filters__container">
          {selectedSportType === "kayak" ||
          selectedSportType === "multimove" ||
          selectedSportType === "skate" ||
          selectedSportType === "" ||
          selectedSportType === null ? (
            <h4>{selectedSportTypeTitle}</h4>
          ) : (
            <></>
          )}

          <div className="c-sportroute-filters">
            {selectedSportType === "mountainbike" && (
              <>
                <SportRouteSlider
                  label={dictionary.afstand}
                  text="0 - 200 KM"
                  name="lengthFilter"
                  passSliderValue={handleSliderFilterChange}
                  min={0}
                  max={200}
                  ref={mbtDistanceFilterRef}
                />

                <Dropdown
                  label={dictionary.percentageOnverhard}
                  options={percentagePavedMBT}
                  name="pavedFilter"
                  passSelectValue={SetNewFilterData}
                  ref={mbtPavedFilterRef}
                />

                <Dropdown
                  label={dictionary.moeilijkheidsGraad}
                  options={difficultyFilter}
                  name="difficultyFilter"
                  passSelectValue={SetNewFilterData}
                  ref={mbtDifficultyFilterRef}
                />

                <Dropdown
                  label={dictionary.typeRoute}
                  options={mountainbikeTypes}
                  name="categoryFilter"
                  passSelectValue={SetNewFilterData}
                  preSelectedValue={parseInt(QueryStringFilter)}
                  ref={mbtTypeFilterRef}
                />
              </>
            )}

            {selectedSportType === "run" && (
              <>
                <SportRouteSlider
                  label={dictionary.afstand}
                  text="0 - 50 KM"
                  name="lengthFilter"
                  passSliderValue={handleSliderFilterChange}
                  min={0}
                  max={50}
                  ref={runDistanceFilterRef}
                />

                <Dropdown
                  label={dictionary.percentageOnverhard}
                  options={percentagePavedRun}
                  name="pavedFilter"
                  passSelectValue={SetNewFilterData}
                  ref={runPavedFilterRef}
                />

                <Dropdown
                  label={dictionary.typeRoute}
                  options={runTypes}
                  name="categoryFilter"
                  passSelectValue={SetNewFilterData}
                  ref={runTypeFilterRef}
                />
              </>
            )}

            {selectedSportType === "horseback" && (
              <div className="c-sportroute-filters">
                <Dropdown
                  label={dictionary.typeRoute}
                  options={horseBackTypes}
                  name="categoryFilter"
                  passSelectValue={SetNewFilterData}
                  ref={horseTypeFilterRef}
                />
                <Dropdown
                  label={dictionary.percentageOnverhard}
                  options={percentagePavedHorseback}
                  name="pavedFilter"
                  passSelectValue={SetNewFilterData}
                  ref={horsePavedFilterRef}
                />
              </div>
            )}

            {selectedSportType &&
              (selectedSportType == "mountainbike" ||
                selectedSportType == "run" ||
                selectedSportType == "horseback") && (
                <p
                  className="c-sportroute-filters-reset"
                  onClick={resetFilters}
                >
                  {dictionary.resetFilters}
                </p>
              )}
          </div>

          {/* Scene swap controls */}
          <div className="c-sportroute-view-toggle-button__container">
            <div
              className={`c-sportroute-view-toggle-button ${
                mapView ? "u-map-toggle__active" : ""
              }`}
              onClick={() => changeMapView(true)}
            >
              <svg
                className={`c-sportroute-view-toggle-button__icon ${
                  mapView ? "u-map-toggle__active" : ""
                }`}
                viewBox="0 0 18 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M5.3125 0.0625C5.40625 0 5.5 0 5.625 0.03125L12.4688 2L16.9688 0.1875C17.4375 0 18 0.34375 18 0.875V11.3438C18 11.6562 17.8125 11.9375 17.5 12.0312L12.6562 13.9688C12.5625 14.0312 12.4688 14.0312 12.3438 14L5.5 12.0312L1 13.8438C0.53125 14.0312 0 13.6875 0 13.1562V2.6875C0 2.375 0.15625 2.09375 0.46875 2L5.3125 0.0625ZM1 12.7812L5 11.1875V1.25L1 2.84375V12.7812ZM12 2.90625L6 1.1875V11.125L12 12.8438V2.90625ZM13 12.7812L17 11.1875V1.25L13 2.84375V12.7812Z" />
              </svg>
            </div>
            <div
              className={`c-sportroute-view-toggle-button ${
                mapView ? "" : "u-map-toggle__active"
              }`}
              onClick={() => changeMapView(false)}
            >
              <svg
                className={`c-sportroute-view-toggle-button__icon ${
                  mapView ? "" : "u-map-toggle__active"
                }`}
                viewBox="0 0 16 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M0.5 1.25C0.5 0.84375 0.8125 0.5 1.25 0.5H2.75C3.15625 0.5 3.5 0.84375 3.5 1.25V2.75C3.5 3.1875 3.15625 3.5 2.75 3.5H1.25C0.8125 3.5 0.5 3.1875 0.5 2.75V1.25ZM2.5 2.5V1.5H1.5V2.5H2.5ZM15.5 1.5C15.75 1.5 16 1.75 16 2C16 2.28125 15.75 2.5 15.5 2.5H5.5C5.21875 2.5 5 2.28125 5 2C5 1.75 5.21875 1.5 5.5 1.5H15.5ZM15.5 6.5C15.75 6.5 16 6.75 16 7C16 7.28125 15.75 7.5 15.5 7.5H5.5C5.21875 7.5 5 7.28125 5 7C5 6.75 5.21875 6.5 5.5 6.5H15.5ZM15.5 11.5C15.75 11.5 16 11.75 16 12C16 12.2812 15.75 12.5 15.5 12.5H5.5C5.21875 12.5 5 12.2812 5 12C5 11.75 5.21875 11.5 5.5 11.5H15.5ZM2.75 5.5C3.15625 5.5 3.5 5.84375 3.5 6.25V7.75C3.5 8.1875 3.15625 8.5 2.75 8.5H1.25C0.8125 8.5 0.5 8.1875 0.5 7.75V6.25C0.5 5.84375 0.8125 5.5 1.25 5.5H2.75ZM1.5 6.5V7.5H2.5V6.5H1.5ZM0.5 11.25C0.5 10.8438 0.8125 10.5 1.25 10.5H2.75C3.15625 10.5 3.5 10.8438 3.5 11.25V12.75C3.5 13.1875 3.15625 13.5 2.75 13.5H1.25C0.8125 13.5 0.5 13.1875 0.5 12.75V11.25ZM2.5 12.5V11.5H1.5V12.5H2.5Z" />
              </svg>
            </div>
          </div>
        </div>
      </div>

      <div className="c-sportroute-content__container">
        <Map
          filters={filtersData}
          location={locationFilterValue}
          resetLocation={resetLocation}
          fetchRoutes={GetMapElements}
          initMapZoom={getZoom()}
          redirectRoute={redirectRoute}
          mapCenter={getCenter()}
          dictionary={dictionary}
          isOverview={IsOverview}
          isMapView={mapView}
        />
        {!mapView && (
          <div className="c-listview-list__container">
            <div className="c-listview-list__scroll">
              {visibleData.routes.length > 0 ? (
                visibleData.routes.map((route) => {
                  return (
                    <RouteListItem
                      key={route.id}
                      route={route}
                      linkText={dictionary.details}
                      redirectRoute={redirectRoute}
                      isOverview={IsOverview}
                    />
                  );
                })
              ) : visibleData.clusters.length > 0 ? (
                <p>{dictionary.zoom}</p>
              ) : (
                <p>{dictionary.geenResultaten}</p>
              )}
            </div>
          </div>
        )}
        {isLoading ? <Loader /> : <></>}
      </div>
    </div>
  );
};

export default SportRoutes;
